import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const createRegistrationPaymentInitialValues = {
  name: "",
  price: "",
  currency: "",
};

export const createRegistrationPaymentValidationSchema = Yup.object({
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  price: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  currency: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export type CreateRegistrationPaymentValues =
  typeof createRegistrationPaymentInitialValues;
